import { FanSpeedApiModel } from '@rocksoft/inroom-sdk';

import { Action } from '@ngrx/store';

export enum FanspeedActionTypes {
  LOAD_FANSPEED = '[Fanspeed] Load Fanspeed',
  SELECT_FANSPEED = '[Fanspeed] Select Fanspeed',
  NO_FANSPEED = '[Fanspeed] No Fanspeed',
  UPDATE_FANSPEED = '[Fanspeed] Update Fanspeed',
}

export interface FanspeedLocationModel extends FanSpeedApiModel {
  HotelCode?: string;
  Room?: string;
}

export class LoadFanspeed implements Action {
  readonly type = FanspeedActionTypes.LOAD_FANSPEED;

  constructor(public payload: FanspeedLocationModel) {}
}

export class SelectFanspeed implements Action {
  readonly type = FanspeedActionTypes.SELECT_FANSPEED;

  constructor(public payload: FanspeedLocationModel) {}
}

export class NoFanspeed implements Action {
  readonly type = FanspeedActionTypes.NO_FANSPEED;
}

export class UpdateFanspeed implements Action {
  readonly type = FanspeedActionTypes.UPDATE_FANSPEED;

  constructor(public payload: { id: string; changes: FanspeedLocationModel }) {}
}

export type FanspeedActionsUnion = LoadFanspeed | SelectFanspeed | NoFanspeed | UpdateFanspeed;
